<template>
  <component-wrapper
    :attribute="attribute"
    :attributeName="attributeName"
    :complete-required="completeRequired"
    :entityName="entityName"
    :helpText="helpText"
    :id="id"
    :label="label"
    :shouldRender="shouldRender"
    :required="!!ruleList.length"
    :showHeader="showHeader"
  >
    <v-text-field
      :data-cy="`${entityName}__textFieldDEA--${attributeName}`"
      :disabled="disabled"
      :filled="styleMap.filled"
      :outlined="styleMap.outlined"
      :placeholder="placeholder"
      :rules="ruleList.concat(DEARule)"
      :solo="styleMap.solo"
      clearable
      counter="9"
      v-model="value"
    >
    </v-text-field>
  </component-wrapper>
</template>
<script>
import userInputMixin from "./userInputMixin";

import ComponentWrapper from "./ComponentWrapper";

export default {
  components: {
    ComponentWrapper,
  },
  data() {
    return {
      DEARule: [
        v =>
          !v ||
          /^[a-zA-Z]{2}[0-9]{7}$/.test(v) ||
          "Must be comprised of 2 letters, followed by 7 numbers.",
      ],
    };
  },
  mixins: [userInputMixin],
};
</script>
